/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type App_viewer$ref = any;
export type NotFoundQueryVariables = {||};
export type NotFoundQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: App_viewer$ref
  |}
|};
export type NotFoundQuery = {|
  variables: NotFoundQueryVariables,
  response: NotFoundQueryResponse,
|};
*/


/*
query NotFoundQuery {
  viewer {
    ...App_viewer
    id
  }
}

fragment Account_viewer on Customer {
  firstname
  email
  ...Login_viewer
  ...Logout_viewer
}

fragment App_viewer on Customer {
  id
  firstname
  lastname
  email
  configs
  freeShippingAmount
  storeCredits(first: 999) {
    edges {
      node {
        id
        name
        creditAmount
        creditRemaining
        brands
        expiry
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ...Search_viewer
  ...Logout_viewer
  ...Footer_viewer
  ...Account_viewer
  ...Nav_viewer
  ...CartView_viewer
  ...EventAlertModal_viewer
}

fragment CartView_viewer on Customer {
  ...ItemList_viewer
  cart {
    id
    subtotal
    lines(first: 999) {
      edges {
        node {
          id
          name
          unitPrice
          quantity
          rowTotal
          unitDiscount
          unitSurcharge
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}

fragment EventAlertModal_viewer on Customer {
  topAlerts(first: 5) {
    edges {
      node {
        id
        content
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment Footer_viewer on Customer {
  footers(first: 3) {
    edges {
      node {
        name
        urls {
          name
          type
          url
          properties
        }
        id
      }
    }
  }
  ...StoreSearch_viewer
}

fragment FreebiePopup_cart on Cart {
  freebies(first: 99) {
    edges {
      node {
        id
        mode
        products(first: 99) {
          edges {
            node {
              id
              name
              urlSlug
              mainImage {
                id
                url
                thumbnail
              }
            }
          }
        }
      }
    }
  }
}

fragment FreebiePopup_viewer on Customer {
  id
}

fragment ItemList_viewer on Customer {
  ...FreebiePopup_viewer
  configs
  cart {
    id
    subtotal
    grandTotal
    loyaltyPoints {
      accruing
    }
    storeCredits(first: 999) {
      edges {
        node {
          id
          name
          stealthMode
          creditAmount
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    isOptFreebiesInCart
    lines(first: 999) {
      edges {
        node {
          id
          name
          isFreebie
          unitPrice
          quantity
          rowTotal
          unitDiscount
          unitSurcharge
          configParent {
            id
            urlSlug
            mainImage {
              id
              thumbnail
            }
          }
          priorityShipping {
            getByDate
          }
          product {
            id
            sku
            name
            urlSlug
            nonStock
            onlineOnly
            preorderDate
            backInStockDate
            stockAvailable
            clearance
            limitedStock
            priorityShipping {
              getByDate
            }
            brand {
              id
              name
            }
            mainImage {
              id
              thumbnail
            }
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    ...FreebiePopup_cart
    freebies(first: 99) {
      edges {
        node {
          id
          mode
          products(first: 99) {
            edges {
              node {
                id
                name
                urlSlug
                mainImage {
                  id
                  url
                  thumbnail
                }
              }
            }
          }
        }
      }
    }
    stores(first: 9999) {
      edges {
        node {
          id
          stocks {
            productId
            stock
          }
        }
      }
    }
  }
}

fragment Login_viewer on Customer {
  email
  configs
}

fragment Logout_viewer on Customer {
  email
}

fragment Nav_viewer on Customer {
  configs
  ...Account_viewer
  ...EventAlertModal_viewer
  categories(first: 999, inMenu: true) {
    edges {
      node {
        id
        name
        urlSlug
        featured
      }
    }
  }
}

fragment Search_viewer on Customer {
  searchAutocomplete(query: "")
}

fragment StoreSearch_viewer on Customer {
  stores(first: 9999) {
    edges {
      node {
        id
        state
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "kind": "Literal",
  "name": "first",
  "value": 999
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "creditAmount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v9 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 9999
  }
],
v10 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlSlug",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnail",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductImage",
  "kind": "LinkedField",
  "name": "mainImage",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "PriorityShipping",
  "kind": "LinkedField",
  "name": "priorityShipping",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "getByDate",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 99
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "NotFoundQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Customer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "App_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "NotFoundQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Customer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstname",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastname",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "configs",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "freeShippingAmount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "CustomerStoreCreditConnection",
            "kind": "LinkedField",
            "name": "storeCredits",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CustomerStoreCreditEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CustomerStoreCredit",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "creditRemaining",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "brands",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "expiry",
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": "storeCredits(first:999)"
          },
          {
            "alias": null,
            "args": (v2/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "App_viewer_storeCredits",
            "kind": "LinkedHandle",
            "name": "storeCredits"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "query",
                "value": ""
              }
            ],
            "kind": "ScalarField",
            "name": "searchAutocomplete",
            "storageKey": "searchAutocomplete(query:\"\")"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 3
              }
            ],
            "concreteType": "FooterConnection",
            "kind": "LinkedField",
            "name": "footers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FooterEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Footer",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FooterUrl",
                        "kind": "LinkedField",
                        "name": "urls",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                          },
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "properties",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v0/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "footers(first:3)"
          },
          {
            "alias": null,
            "args": (v9/*: any*/),
            "concreteType": "StoreConnection",
            "kind": "LinkedField",
            "name": "stores",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "StoreEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Store",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "state",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "stores(first:9999)"
          },
          {
            "alias": null,
            "args": (v10/*: any*/),
            "concreteType": "TopAlertConnection",
            "kind": "LinkedField",
            "name": "topAlerts",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TopAlertEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TopAlert",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "content",
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": "topAlerts(first:5)"
          },
          {
            "alias": null,
            "args": (v10/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "App_viewer_topAlerts",
            "kind": "LinkedHandle",
            "name": "topAlerts"
          },
          {
            "alias": null,
            "args": [
              (v1/*: any*/),
              {
                "kind": "Literal",
                "name": "inMenu",
                "value": true
              }
            ],
            "concreteType": "CategoryConnection",
            "kind": "LinkedField",
            "name": "categories",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CategoryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Category",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      (v3/*: any*/),
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "featured",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "categories(first:999,inMenu:true)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Cart",
            "kind": "LinkedField",
            "name": "cart",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "subtotal",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "grandTotal",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LoyaltyPoints",
                "kind": "LinkedField",
                "name": "loyaltyPoints",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accruing",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "StoreCreditConnection",
                "kind": "LinkedField",
                "name": "storeCredits",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoreCreditEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StoreCredit",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v0/*: any*/),
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "stealthMode",
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": "storeCredits(first:999)"
              },
              {
                "alias": null,
                "args": (v2/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "CartView_storeCredits",
                "kind": "LinkedHandle",
                "name": "storeCredits"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isOptFreebiesInCart",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "QuoteLineConnection",
                "kind": "LinkedField",
                "name": "lines",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QuoteLineEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "QuoteLine",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v0/*: any*/),
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isFreebie",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "unitPrice",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "quantity",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "rowTotal",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "unitDiscount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "unitSurcharge",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Product",
                            "kind": "LinkedField",
                            "name": "configParent",
                            "plural": false,
                            "selections": [
                              (v0/*: any*/),
                              (v11/*: any*/),
                              (v13/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v14/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Product",
                            "kind": "LinkedField",
                            "name": "product",
                            "plural": false,
                            "selections": [
                              (v0/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "sku",
                                "storageKey": null
                              },
                              (v3/*: any*/),
                              (v11/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "nonStock",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "onlineOnly",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "preorderDate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "backInStockDate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "stockAvailable",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "clearance",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "limitedStock",
                                "storageKey": null
                              },
                              (v14/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Brand",
                                "kind": "LinkedField",
                                "name": "brand",
                                "plural": false,
                                "selections": [
                                  (v0/*: any*/),
                                  (v3/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v13/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": "lines(first:999)"
              },
              {
                "alias": null,
                "args": (v2/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "CartView_lines",
                "kind": "LinkedHandle",
                "name": "lines"
              },
              {
                "alias": null,
                "args": (v15/*: any*/),
                "concreteType": "FreebieTierConnection",
                "kind": "LinkedField",
                "name": "freebies",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FreebieTierEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FreebieTier",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v0/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mode",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v15/*: any*/),
                            "concreteType": "ProductConnection",
                            "kind": "LinkedField",
                            "name": "products",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProductEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Product",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v0/*: any*/),
                                      (v3/*: any*/),
                                      (v11/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProductImage",
                                        "kind": "LinkedField",
                                        "name": "mainImage",
                                        "plural": false,
                                        "selections": [
                                          (v0/*: any*/),
                                          (v8/*: any*/),
                                          (v12/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "products(first:99)"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "freebies(first:99)"
              },
              {
                "alias": null,
                "args": (v9/*: any*/),
                "concreteType": "StoreConnection",
                "kind": "LinkedField",
                "name": "stores",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoreEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Store",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v0/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StockLevel",
                            "kind": "LinkedField",
                            "name": "stocks",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "productId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "stock",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "stores(first:9999)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "44b601894a0c9bedbd904f1afa451ff2",
    "id": null,
    "metadata": {},
    "name": "NotFoundQuery",
    "operationKind": "query",
    "text": "query NotFoundQuery {\n  viewer {\n    ...App_viewer\n    id\n  }\n}\n\nfragment Account_viewer on Customer {\n  firstname\n  email\n  ...Login_viewer\n  ...Logout_viewer\n}\n\nfragment App_viewer on Customer {\n  id\n  firstname\n  lastname\n  email\n  configs\n  freeShippingAmount\n  storeCredits(first: 999) {\n    edges {\n      node {\n        id\n        name\n        creditAmount\n        creditRemaining\n        brands\n        expiry\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...Search_viewer\n  ...Logout_viewer\n  ...Footer_viewer\n  ...Account_viewer\n  ...Nav_viewer\n  ...CartView_viewer\n  ...EventAlertModal_viewer\n}\n\nfragment CartView_viewer on Customer {\n  ...ItemList_viewer\n  cart {\n    id\n    subtotal\n    lines(first: 999) {\n      edges {\n        node {\n          id\n          name\n          unitPrice\n          quantity\n          rowTotal\n          unitDiscount\n          unitSurcharge\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n}\n\nfragment EventAlertModal_viewer on Customer {\n  topAlerts(first: 5) {\n    edges {\n      node {\n        id\n        content\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment Footer_viewer on Customer {\n  footers(first: 3) {\n    edges {\n      node {\n        name\n        urls {\n          name\n          type\n          url\n          properties\n        }\n        id\n      }\n    }\n  }\n  ...StoreSearch_viewer\n}\n\nfragment FreebiePopup_cart on Cart {\n  freebies(first: 99) {\n    edges {\n      node {\n        id\n        mode\n        products(first: 99) {\n          edges {\n            node {\n              id\n              name\n              urlSlug\n              mainImage {\n                id\n                url\n                thumbnail\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment FreebiePopup_viewer on Customer {\n  id\n}\n\nfragment ItemList_viewer on Customer {\n  ...FreebiePopup_viewer\n  configs\n  cart {\n    id\n    subtotal\n    grandTotal\n    loyaltyPoints {\n      accruing\n    }\n    storeCredits(first: 999) {\n      edges {\n        node {\n          id\n          name\n          stealthMode\n          creditAmount\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    isOptFreebiesInCart\n    lines(first: 999) {\n      edges {\n        node {\n          id\n          name\n          isFreebie\n          unitPrice\n          quantity\n          rowTotal\n          unitDiscount\n          unitSurcharge\n          configParent {\n            id\n            urlSlug\n            mainImage {\n              id\n              thumbnail\n            }\n          }\n          priorityShipping {\n            getByDate\n          }\n          product {\n            id\n            sku\n            name\n            urlSlug\n            nonStock\n            onlineOnly\n            preorderDate\n            backInStockDate\n            stockAvailable\n            clearance\n            limitedStock\n            priorityShipping {\n              getByDate\n            }\n            brand {\n              id\n              name\n            }\n            mainImage {\n              id\n              thumbnail\n            }\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    ...FreebiePopup_cart\n    freebies(first: 99) {\n      edges {\n        node {\n          id\n          mode\n          products(first: 99) {\n            edges {\n              node {\n                id\n                name\n                urlSlug\n                mainImage {\n                  id\n                  url\n                  thumbnail\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    stores(first: 9999) {\n      edges {\n        node {\n          id\n          stocks {\n            productId\n            stock\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment Login_viewer on Customer {\n  email\n  configs\n}\n\nfragment Logout_viewer on Customer {\n  email\n}\n\nfragment Nav_viewer on Customer {\n  configs\n  ...Account_viewer\n  ...EventAlertModal_viewer\n  categories(first: 999, inMenu: true) {\n    edges {\n      node {\n        id\n        name\n        urlSlug\n        featured\n      }\n    }\n  }\n}\n\nfragment Search_viewer on Customer {\n  searchAutocomplete(query: \"\")\n}\n\nfragment StoreSearch_viewer on Customer {\n  stores(first: 9999) {\n    edges {\n      node {\n        id\n        state\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fecbc1c92e6ac8265e2f73786d1d1d6a';

module.exports = node;
